import { NavLink, Link, useNavigate } from "react-router-dom";
import { useAuthStore } from "../stores/auth";
import { logout } from "../api/auth";

const LINKS = [
  { to: "/markets", label: "Markets" },
  { to: "/trade/BTCUSDT", label: "Trade" },
  { to: "/intel", label: "Intel" },
  { to: "/watchlist", label: "Watchlist" },
  { to: "/portfolio", label: "Portfolio" },
  { to: "/orders", label: "Orders" },
  { to: "/alerts", label: "Alerts" },
  { to: "/providers", label: "Providers" },
  { to: "/academy", label: "Academy" },
];

export function TopNav() {
  const user = useAuthStore((s) => s.user);
  const clear = useAuthStore((s) => s.clear);
  const navigate = useNavigate();

  async function onLogout() {
    try {
      await logout();
    } catch {
      // best effort
    }
    clear();
    navigate("/");
  }

  return (
    <header className="topnav">
      <Link to="/" className="topnav-brand">
        Bitxian
      </Link>
      <nav className="topnav-links">
        {LINKS.map((l) => (
          <NavLink
            key={l.to}
            to={l.to}
            className={({ isActive }) => (isActive ? "topnav-link active" : "topnav-link")}
          >
            {l.label}
          </NavLink>
        ))}
      </nav>
      <div className="topnav-user">
        {user ? (
          <>
            <span className="topnav-email">{user.email}</span>
            <Link to="/settings" className="topnav-link">
              Settings
            </Link>
            <button type="button" className="btn btn-ghost" onClick={onLogout}>
              Sign out
            </button>
          </>
        ) : (
          <>
            <Link to="/login" className="btn btn-ghost">
              Sign in
            </Link>
            <Link to="/signup" className="btn btn-primary">
              Sign up
            </Link>
          </>
        )}
      </div>
    </header>
  );
}
